import useStyles from './MonetisationHealthTooltip.styles';

type MonetisationHealthTooltipProps = {
  title: string;
  colour: string;
};

export const MonetisationHealthTooltip = ({ title, colour }: MonetisationHealthTooltipProps) => {
  const classes = useStyles();

  return (
    <div>
      <div>
        <div className={classes.title} style={{ color: colour }}>
          {title}
        </div>
        :<div className={classes.percentage}> {`{valueY}%`}</div>
      </div>
      <div>{`{valueX}`}</div>
    </div>
  );
};

export default MonetisationHealthTooltip;
